module.exports = __webpack_public_path__ + "static/img/Servicio2.141ab64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Servicio2.png
// module id = GGA2
// module chunks = 0